module.exports = __webpack_public_path__ + "img/se.e879bfc5.svg";